/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteInstrumentSyncEntity} from '../api'

export const useMutationDeleteInstrumentSyncEntity = createReactQueryMutationHook('deleteInstrumentSyncEntity', deleteInstrumentSyncEntity)
